<template>
    <div id="todo-app" class="z-10 border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('e-journal')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <!-- Фильтры -->
            <ListFilters :sidebarToggle="toggleSidebar" />
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">
            <!-- Поиск -->
            <div class="flex border d-theme-dark-bg items-center">
                <feather-icon class="md:inline-flex ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>
            </div>
            <!-- список студентов -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                :key="$vs.rtl">

                    <ul v-if="eJournalList.length">
                        <li
                            class="todo_todo-item cursor-pointer"
                            @click="openView(item)"
                            v-for="(item, index) in eJournalList"
                            :key="`d_${index}`"
                            :style="[{transitionDelay: (index * 0.1) + 's'}]">
                                <ListItem :item="item" />
                        </li>
                    </ul>

                    <!-- Выводим сообщение если данных нет -->
                    <div class="mt-4 ml-5 mr-5" v-if="emptyMessage">
                        <vs-alert active="true">
                            {{$t('no_data_text')}}
                        </vs-alert>
                    </div>

                    <!-- В этот див выводил лоадер -->
                    <div id="infinite_loader" class="vs-con-loading__container"></div>
            </component>
        </div>

    </div>
</template>

<script>
import eJournal from '@/store/modules/e_journal.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import ListFilters from './ListFilters.vue'
import ListItem from './ListItem.vue'
import ItemView from './ItemView'
import { mapActions, mapGetters } from 'vuex'

export default {
    data() {
        return {
            clickNotClose: false,
            emptyMessage: false,
            isSidebarActive: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            }
        };
    },
    components: {
        VuePerfectScrollbar,
        ListItem,
        ListFilters,
        ItemView
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        ...mapGetters({
            eJournalList: 'e_journal/getJournalList'
        }),
        windowWidth() { return this.$store.state.windowWidth }
    },
    created: function() {
        // Регистрируем стор
        if(!this.$store.hasModule('e_journal'))
            this.$store.registerModule('e_journal', eJournal)

        this.setSidebarWidth()

        this.setFIlter()

        //Запращиваем журналы
        this.getEJournal()
    },
    beforeDestroy () {
        // Если покидаем текущий компонент, удаляем стор
        this.$store.unregisterModule('e_journal')
        localStorage.el_journal_notification = 0
    },
    methods: {
        ...mapActions({
            fetchJournaltList: 'e_journal/fetchJournaltList',
        }),
        setFIlter() {
            if (Object.keys(this.$route.query).length) {
                this.$store.commit('e_journal/SET_QUERY', this.$route.query)
            }
        },
        async openView(item) {
            let query = {uid:item.uid}
            Object.keys(this.$route.query).forEach(key => {
                query[key] = this.$route.query[key]
            })
            this.$router.push({name:'e-journal-detail',query: query })
        },
        async getEJournal() {
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })
                const res = await this.fetchJournaltList()

                if(!res.length)
                    this.emptyMessage = true
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close('#infinite_loader > .con-vs-loading')
            }
        },
        toggleSidebar (value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            // if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                // this.isSidebarActive = this.clickNotClose = true
            }
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.emc__actions{
    .con-vs-tabs{
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs{
        display: none;
    }
}
.emc_list_tabs{
    .con-ul-tabs{
        display: none;
    }
    .vs-tabs--content{
        padding: 0px;
    }
}
.filters_scroll_area{
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher{
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher){
        height: 100%;
    }
}
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    .infinite_alert{
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.full-vs-sidebar{
    .mail-sidebar-content{
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header{
        box-shadow: 0 4px 6px rgba(0,0,0,.04);
        border-bottom: 1px solid #eee;
    }
}
</style>
